import { render, staticRenderFns } from "./LoanAccountClosed.vue?vue&type=template&id=56ebf19a"
import script from "./LoanAccountClosed.vue?vue&type=script&lang=js"
export * from "./LoanAccountClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports